<template>
  <PopupRouterViewDetail label="Surat Jalan Supply For Subcontract Detail" @hideMethod="onHidden"
                         :isShowCopyData="false">

    <!-- APP_DETAIL_HEADER -->

    <b-card header="Surat Jalan Supply for Subcontract" class="mb-3 card-max-width">
      <b-row>
        <b-col cols="12" lg="6">
          <app-label label-cols-lg="12" size="sm" type="generatednumber" label="No Surat Jalan"
                     :model="model.suratJalanNo"/>
          
          <app-input-combobox-autocomplete :options="workOrderSupplySubContracts" optionsLabel="materialIssueNumber"
                                           optionsKey="id" label-cols-lg="12" label="Material Issue Number (W/O No)"
                                           id="fieldset-work-order-supply-subcontract" size="sm"
                                           :model.sync="model.workOrderSupplySubcontractId"
                                           :selected="model.workOrderSupplySubcontract != null ? model.workOrderSupplySubcontract.materialIssueNumber : ''"
                                           @input="getWorkOrderSupplySubContracts" @change="updateData"
                                           :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true"
                                           @onSelectMethod="setSelectedWorkOrderSupplySubcontract"/>
          
          <app-input-datepicker id="fieldset-delivery-date" label-cols-lg="12" label="Delivery Date" size="sm"
                                :model.sync="model.deliveryDate"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="false"/>
        </b-col>
        <b-col cols="12" lg="6">
          <app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id"
                                           label-cols-lg="12" label="Purchase Order" id="fieldset-purchase-order"
                                           size="sm" :model.sync="model.purchaseOrderId"
                                           :selected="model.purchaseOrder != null ? model.purchaseOrder.purchaseOrderNumber : ''"
                                           @input="getPurchaseOrders" @change="updateData" :isEditable="false"
                                           :isUpdatable="false" :isSelectMethodExists="true"
                                           @onSelectMethod="setSelectedPurchaseOrder"/>
          <app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12"
                                           label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"
                                           :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors"
                                           @change="updateData" :isEditable="false" :isUpdatable="false"
                                           :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor"/>
        </b-col>

      </b-row>
    </b-card>

    <b-card header="Driver Information" class="mb-3 card-max-width">
      <b-row>
        <b-col cols="12" lg="6">
          <app-input-textbox id="fieldset-driver-name" label-cols-lg="12" label="Driver Name"
                             label-for="input-driver-name" size="sm" 
                             :model.sync="model.driverName" @change="updateData"
                             :isUpdatable="false"
                              :is-editable="false"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <app-input-textbox id="fieldset-vehicle-number" label-cols-lg="12" label="Vehicle Number"
                             label-for="input-vehicle-number" size="sm" :model.sync="model.vehicleNumber"
                             @change="updateData"
                             :isUpdatable="false"
                             :is-editable="false"
          />
        </b-col>

      </b-row>
    </b-card>

    <b-card header="PIC Surat Jalan" class="mb-3 card-max-width">
      <b-row>
        <b-col cols="12" lg="6">
          <app-input-textbox id="fieldset-pic-surat-jalan" label-cols-lg="12" label="PIC"
                             label-for="input-pic-surat-jalan" size="sm" :model.sync="model.picSuratJalan" @change="updateData"
                             :isUpdatable="null" :is-editable="false"/>
        </b-col>
        <b-col cols="12" lg="6">
          <app-input-textbox id="fieldset-admin-surat-jalan" label-cols-lg="12" label="Admin"
                             label-for="input-admin-surat-jalan" size="sm" :model.sync="model.adminSuratJalan"
                             @change="updateData" :isUpdatable="null" :is-editable="false"/>
        </b-col>

      </b-row>
    </b-card>

    <app-table-input-popup title="List Part to Delivery" :bordered="true" :items="suratJalanSupplyForSubcontractDetails"
                           :fields="fieldsSuratJalanSupplyForSubcontractDetail" :busy="isDataLoading"
                           :sort-by.sync="sortBySuratJalanSupplyForSubcontractDetail"
                           :sort-desc.sync="sortDescSuratJalanSupplyForSubcontractDetail" small responsive
                           @editButtonMethod="editRowDataSuratJalanSupplyForSubcontractDetail"
                           @deleteButtonMethod="deleteRowDataSuratJalanSupplyForSubcontractDetail"
                           @showPopupAddMethod="resetDataSuratJalanSupplyForSubcontractDetail()"
                           @showPopupUploadMethod="showPopupUploadSuratJalanSupplyForSubcontractDetail()"
                           @downloadMethod="downloadSuratJalanSupplyForSubcontractDetail()"
                           @addFromClipboardMethod="addFromClipboardSuratJalanSupplyForSubcontractDetail()"
                           @replaceFromClipboardMethod="replaceFromClipboardSuratJalanSupplyForSubcontractDetail()"
                           :showActionButton="false"
                           :showEditButton="false"
                           :showDeleteButton="false"
                           :showAddButton="false"
                           :showAddFromClipboardButton="false"
                           :showReplaceFromClipboardButton="false"
                           :showUploadButton="false"
                           :showDownloadButton="false"
                           :isDownloadBusy="isDownloadSuratJalanSupplyForSubcontractDetail"
    >
      <template #top-row v-if="isShowSuratJalanSupplyForSubcontractDetailFilter">
        <b-th></b-th>
        <b-th></b-th>
        <b-th stacked-heading="Part">
          <v-select append-to-body label="partNumber" :options="parts"
                    :value="filterSuratJalanSupplyForSubcontractDetail.partId" :reduce="item => item.id"
                    v-model="filterSuratJalanSupplyForSubcontractDetail.partId" @search="getParts"
                    :filterable="true"></v-select>
        </b-th>
        <b-th stacked-heading="Order Qty">
          <b-form-input id="input-order-qty-table" v-model="filterSuratJalanSupplyForSubcontractDetail.orderQty"
                        size="sm"></b-form-input>
        </b-th>
        <b-th stacked-heading="Delivery Qty">
          <b-form-input id="input-delivery-qty-table" v-model="filterSuratJalanSupplyForSubcontractDetail.deliveryQty"
                        size="sm"></b-form-input>
        </b-th>

        <b-th></b-th>
      </template>
      <template v-slot:cell(no)="row">
        {{
          ((row.index + 1) + (suratJalanSupplyForSubcontractDetailPageSize * (currentSuratJalanSupplyForSubcontractDetailPage - 1)))
        }}
      </template>
      <template v-slot:table-busys>
        <div class="text-center my-2">
          <b-spinner class="align-middle text-primary"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(part)="row">
        <app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
                                         :id="'input-surat-jalan-supply-for-subcontract-detail-part-' + row.index"
                                         label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"
                                         @change="saveInputSuratJalanSupplyForSubcontractDetail(row.item)"
                                         :selected="row.item.part != null ? row.item.part.partNumber : ''"
                                         @input="getParts" :loading="isPartComboLoading" :isEditable="false"
                                         :isUpdatable="false" :nolabel="true"/>
      </template>
      <template v-slot:cell(partName)="row">
        <app-label label-cols-lg="12" size="sm" label="Part Name"
                   :model="(row.item.part != null) ? row.item.part.partName : null"/>
      </template>
      <template v-slot:cell(orderQty)="row">
        <app-input-textbox :id="'input-surat-jalan-supply-for-subcontract-detail-order-qty-' + row.index"
                           label-cols-lg="12" label="Order Qty" size="sm" :model.sync="row.item.orderQty"
                           @change="saveInputSuratJalanSupplyForSubcontractDetail(row.item)" :isEditable="false"
                           :isUpdatable="false" :nolabel="true"/>
      </template>
      <template v-slot:cell(deliveryQty)="row">
        <app-input-textbox :id="'input-surat-jalan-supply-for-subcontract-detail-delivery-qty-' + row.index"
                           label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"
                           @change="saveInputSuratJalanSupplyForSubcontractDetail(row.item)" :isEditable="false"
                           :isUpdatable="false" :nolabel="true"/>
      </template>

      <template v-slot:form-add-detail>
        <SuratJalanSupplyForSubcontractDetailInput
            :openPopup="isShowPopupSuratJalanSupplyForSubcontractDetail"
            :modelId="suratJalanSupplyForSubcontractDetailId"
            @resetMethod="resetModal"
            @addButtonMethod="addRowDataSuratJalanSupplyForSubcontractDetail"/>
      </template>
      <template v-slot:upload-detail>
        <SuratJalanSupplyForSubcontractDetailUpload
            :openPopup="isShowPopupUploadSuratJalanSupplyForSubcontractDetail"
            @resetMethod="resetModal"
            @uploadButtonMethod="uploadDataSuratJalanSupplyForSubcontractDetail"
            :parentId="modelId"
        />
      </template>
      <template #row-details="row">
        <b-card>
          <app-label label-cols-lg="12" size="sm" label="Part Name"
                     :model="(row.item.part != null) ? row.item.part.partName : null"/>
          
          <app-input-textbox :id="'input-surat-jalan-supply-for-subcontract-detail-order-qty-' + row.index"
                             label-cols-lg="12" label="Order Qty" size="sm" :model.sync="row.item.orderQty"
                             @change="saveInputSuratJalanSupplyForSubcontractDetail(row.item)" :isUpdatable="false"
                             :isEditable="false"/>
          
          <app-input-textbox :id="'input-surat-jalan-supply-for-subcontract-detail-delivery-qty-' + row.index"
                             label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"
                             @change="saveInputSuratJalanSupplyForSubcontractDetail(row.item)" :isUpdatable="false"
                             :isEditable="false"/>
        </b-card>
      </template>

    </app-table-input-popup>
    <!-- END_APP_DETAIL_HEADER -->

    <b-overlay :show="isBusy" no-wrap></b-overlay>

    <template #modal-left-button>
      <b-overlay
          :show="isBusy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="float-right "
      >
        <b-button size="sm" variant="secondary" class="float-right btn-outline-success" @click="printSuratJalan()">Print Surat Jalan</b-button>
      </b-overlay>
    </template>

    <PopupPDF :openPopup="isShowPopupPDF"
              :pdfUrl="pdfUrl"
              @resetModalMethod="resetModal"
              label="Surat Jalan (Preview)" />
    
  </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import {validationMixin} from "vuelidate";
import {required, minLength} from "vuelidate/lib/validators";
import SuratJalanSupplyForSubcontract from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontract';
import SuratJalanSupplyForSubcontractList
  from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractList';
import SuratJalanSupplyForSubcontractFilter
  from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import SuratJalanSupplyForSubcontractDetail
  from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetail';
import SuratJalanSupplyForSubcontractDetailFilter
  from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter
  from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import SuratJalanSupplyForSubcontractDetailInput
  from '@/views/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetailInput';
import SuratJalanSupplyForSubcontractDetailUpload
  from '@/views/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from "@/components/PopupPDF.vue";

export default {
  components: {
    PopupPDF,
    AppLabel,
    AppInputComboboxAutocomplete,
    AppInputDatepicker,
    AppInputDatepickerRange,
    AppInputTextbox,
    SuratJalanSupplyForSubcontractDetailInput, SuratJalanSupplyForSubcontractDetailUpload,
    AppTableInput,
    AppTableInputPopup,
    PopupRouterViewDetail,
    PopupRouterView,
  },
  mixins: [validationMixin],
  validations: {
    model: {},
  },
  data() {
    return {
      errorMessage: {},
      datas: Array(),
      selectAll: false,
      sortBy: '',
      sortDesc: '',
      pagingOptions: [
        {value: '10', text: '10', selected: true},
        {value: '25', text: '25'},
        {value: '50', text: '50'},
        {value: '100', text: '100'},
      ],
      fieldsSuratJalanSupplyForSubcontractDetail: [
        {"frontActions": {"class": "th-actions", "label": ""}},
        {"no": {"class": "th-number d-stack-none"}},
        {"part": {"class": "th-part first-child", "label": "Part", key: 'part', sortable: false}},
        {"partName": {"class": "th-part-name", "label": "Part Name", key: 'partName', sortable: false}},
        {"orderQty": {"class": "th-order-qty last-child", "label": "Order Qty", key: 'orderQty', sortable: false}},
        {
          "deliveryQty": {
            "class": "th-delivery-qty d-stack-none",
            "label": "Delivery Qty",
            key: 'deliveryQty',
            sortable: false
          }
        },
        {"actions": {"class": "th-actions d-stack-show", "label": ""}}
      ],
      busy: false,
      isBusy: false,
      isDataLoading: false,
      selected: '',
      pageSizeOptions: 10,
      pageIndex: 0,
      sortingBy: Array(),
      modelId: null,
      model: {},
      modelSuratJalanSupplyForSubcontractDetail: {},
      isShowPopupSuratJalanSupplyForSubcontractDetail: false,
      isShowPopupUploadSuratJalanSupplyForSubcontractDetail: false,
      filterSuratJalanSupplyForSubcontract: null,
      currentSuratJalanSupplyForSubcontractPage: 1,
      suratJalanSupplyForSubcontractPageSize: 10,
      sortBySuratJalanSupplyForSubcontract: '',
      sortDescSuratJalanSupplyForSubcontract: '',
      filterSuratJalanSupplyForSubcontractDetail: null,
      currentSuratJalanSupplyForSubcontractDetailPage: 1,
      suratJalanSupplyForSubcontractDetailPageSize: 10,
      sortBySuratJalanSupplyForSubcontractDetail: '',
      sortDescSuratJalanSupplyForSubcontractDetail: '',
      sortingBySuratJalanSupplyForSubcontractDetail: [],
      suratJalanSupplyForSubcontractDetails: [],
      suratJalanSupplyForSubcontractDetailId: '',
      totalSuratJalanSupplyForSubcontractDetailRow: 0,
      isShowSuratJalanSupplyForSubcontractDetailFilter: false,
      isDownloadSuratJalanSupplyForSubcontractDetail: false,
      parts: [],
      workOrderSupplySubContracts: [],
      workOrderSupplySubcontracts: [],
      isWorkOrderSupplySubcontractComboLoading: false,
      purchaseOrders: [],
      vendors: [],
      isShowPopupConfirmation: false,
      isDataCommited: false,
      mainRecordId: '',
      isWorkOrderSupplySubContractComboLoading: false,
      isPurchaseOrderComboLoading: false,
      isVendorComboLoading: false,
      isSuratJalanSupplyForSubcontractComboLoading: false,
      isPartComboLoading: false,
      isWorkOrderSupplySubContractDetailComboLoading: false,
      isShowPopupPDF: false,
      pdfUrl: '',
    }
  },
  methods: {
    async printSuratJalan() {
      let this_ = this;
      this_.isBusy = true;
      return this_.$http.get('SuratJalanSupplyForSubcontract/printsuratjalan/' + this.modelId)
          .then(async function(response){
            if (response.data) {
              this_.isBusy = false;
              return this_.showPopupPDF(response.data.download)
            }
            this_.isBusy = false;
            return null;
          })
          .catch(function(error){
            this_.isBusy = false;
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
          });
    },
    showPopupPDF(url) {
      this.isShowPopupPDF = true;
      this.pdfUrl = url;
    },
    showPopupWithMessage: async function (message) {
      const msg = this.$createElement;
      let msgNode = '';
      let result = false;
      msgNode = msg('div', {domProps: {innerHTML: '<p>' + message + '</p>'}})
      await this.$bvModal.msgBoxConfirm([msgNode], {
        title: 'Alert',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        cancelVariant: 'secondary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(e => {
        if (e) {
          result = true;
        }
      });
      return result;
    },
    getSuratJalanSupplyForSubcontract: async function (id) {
      this.isBusy = true;
      SuratJalanSupplyForSubcontract.getData(this, id).then(result => {
        this.model = result;
        this.mainRecordId = String(result.mainRecordId);
        let promises = Array();


        Promise.all(promises).then((results) => {
          this.isBusy = false;
        });
      }).catch(error => {
        this.isBusy = false;
      });
    },
    downloadData() {
      this.isDownloadSuratJalanSupplyForSubcontract = true;
      this.filterSuratJalanSupplyForSubcontract.id = this.modelId;
      SuratJalanSupplyForSubcontract.downloadDataDetail(this, this.filterSuratJalanSupplyForSubcontract).then(result => {
        this.isDownloadSuratJalanSupplyForSubcontract = false;
      }).catch(error => {
        this.isDownloadSuratJalanSupplyForSubcontract = false;
      })
    },
    getSuratJalanSupplyForSubcontractDetails: async function (isAddRow) {
      let filter = {};
      Object.assign(filter, this.filterSuratJalanSupplyForSubcontractDetail);
      if (this.modelId == null) return;
      filter.suratJalanSupplyForSubcontractId = this.modelId;
      filter.draftMode = "0";
      if (this.sortBySuratJalanSupplyForSubcontractDetail != null) {
        this.sortingBySuratJalanSupplyForSubcontractDetail[this.sortBySuratJalanSupplyForSubcontractDetail] = this.sortDescSuratJalanSupplyForSubcontractDetail;
      }
      let currentPage = (this.currentSuratJalanSupplyForSubcontractDetailPage - 1);
      if (isAddRow) {
        let totalData = this.totalSuratJalanSupplyForSubcontractDetailRow + 1;
        let page = Math.ceil(totalData / this.suratJalanSupplyForSubcontractDetailPageSize);
        currentPage = page - 1;
      }
      // disable paging start
      currentPage = null;
      this.suratJalanSupplyForSubcontractDetailPageSize = 0;
      // disable paging end
      SuratJalanSupplyForSubcontractDetail.getList(this, filter, this.sortingBySuratJalanSupplyForSubcontractDetail, currentPage, this.suratJalanSupplyForSubcontractDetailPageSize).then(result => {
        this.currentSuratJalanSupplyForSubcontractDetailPage = currentPage + 1;
        this.suratJalanSupplyForSubcontractDetails = result.data;
        this.totalSuratJalanSupplyForSubcontractDetailRow = result.dataCount;
      }).catch(error => {
      });
    },
    getSuratJalanSupplyForSubcontracts: async function (input) {
      let filter = new SuratJalanSupplyForSubcontractFilter();
      if (input != undefined) {
        filter.SuratJalanNo = input;
      }
      this.isSuratJalanSupplyForSubcontractComboLoading = true;
      SuratJalanSupplyForSubcontract.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.suratJalanSupplyForSubcontracts = result.data
            }
            this.isSuratJalanSupplyForSubcontractComboLoading = false;
          })
          .catch(error => {
          });
    },
    getParts: async function (input) {
      let filter = new PartFilter();
      if (input != undefined) {
        filter.partNumber = input;
      }
      this.isPartComboLoading = true;
      Part.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.parts = result.data
            }
            this.isPartComboLoading = false;
          })
          .catch(error => {
          });
    },
    getWorkOrderSupplySubContractDetails: async function (input) {
      let filter = new WorkOrderSupplySubContractDetailFilter();
      if (input != undefined) {
        filter.part = input;
      }
      this.isWorkOrderSupplySubContractDetailComboLoading = true;
      WorkOrderSupplySubContractDetail.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.workOrderSupplySubContractDetails = result.data
            }
            this.isWorkOrderSupplySubContractDetailComboLoading = false;
          })
          .catch(error => {
          });
    },
    getWorkOrderSupplySubContracts: async function (input) {
      let filter = new WorkOrderSupplySubContractFilter();
      if (input != undefined) {
        filter.materialIssueNumber = input;
      }
      filter.fwDocStat = '0,1';
      filter.exactType.fwDocStat = '1';
      WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.workOrderSupplySubContracts = result.data
            }
          })
          .catch(error => {
          });
    },
    setSelectedWorkOrderSupplySubcontractExecuted(item) {
      let _this = this;
      if (item == undefined || item == null) {
        this.model.workOrderSupplySubcontractId = null;
        this.model.workOrderSupplySubcontract = null;
        this.isBusy = true;
        SuratJalanSupplyForSubcontract.resetDocument(this, this.model.id).then(result => {
          this.getSuratJalanSupplyForSubcontract(this.model.id).then(result => {
            this.getSuratJalanSupplyForSubcontractDetails();
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        }).catch(error => {
          this.isBusy = false;
        });
      } else {
        this.model.workOrderSupplySubcontractId = item.id;
        this.model.workOrderSupplySubcontract = item;

        this.isBusy = true;
        SuratJalanSupplyForSubcontract.copyFromDocument(this, 'workordersupplysubcontract', item.id, this.model.id).then(result => {
          this.getSuratJalanSupplyForSubcontract(this.model.id).then(result => {
            this.getSuratJalanSupplyForSubcontractDetails();
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        }).catch(error => {
          this.isBusy = false;
        });
      }
    },
    setSelectedWorkOrderSupplySubcontract(item) {
      if (item) {
        var itemId = Number(item.id);
        if (this.model.workOrderSupplySubcontractId == itemId) return;
      }

      if (this.suratJalanSupplyForSubcontractDetails != null && this.suratJalanSupplyForSubcontractDetails.length > 0) {
        const msg = this.$createElement;
        const msgNode = msg('div', {
          domProps: {
            innerHTML: '<p>Perubahan terhadap Surat Jalan Supply For Subcontract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
          }
        });
        this.$bvModal.msgBoxConfirm([msgNode], {
          title: 'Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
            .then(value => {
              if (value) {
                this.setSelectedWorkOrderSupplySubcontractExecuted(item);
              }
            })
            .catch(err => {
            })
      } else {
        this.setSelectedWorkOrderSupplySubcontractExecuted(item);
      }
    },
    getPurchaseOrders: async function (input) {
      let filter = new PurchaseOrderFilter();
      if (input != undefined) {
        filter.purchaseOrderNumber = input;
      }
      filter.fwDocStat = '0,1';
      filter.exactType.fwDocStat = '1';
      PurchaseOrder.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.purchaseOrders = result.data
            }
          })
          .catch(error => {
          });
    },
    setSelectedPurchaseOrderExecuted(item) {
      let _this = this;
      if (item == undefined || item == null) {
        this.model.purchaseOrderId = null;
        this.model.purchaseOrder = null;
        this.isBusy = true;
        SuratJalanSupplyForSubcontract.resetDocument(this, this.model.id).then(result => {
          this.getSuratJalanSupplyForSubcontract(this.model.id).then(result => {
            this.getSuratJalanSupplyForSubcontractDetails();
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        }).catch(error => {
          this.isBusy = false;
        });
      } else {
        this.model.purchaseOrderId = item.id;
        this.model.purchaseOrder = item;

        this.isBusy = true;
        SuratJalanSupplyForSubcontract.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
          this.getSuratJalanSupplyForSubcontract(this.model.id).then(result => {
            this.getSuratJalanSupplyForSubcontractDetails();
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        }).catch(error => {
          this.isBusy = false;
        });
      }
    },
    setSelectedPurchaseOrder(item) {
      if (item) {
        var itemId = Number(item.id);
        if (this.model.purchaseOrderId == itemId) return;
      }

      if (this.suratJalanSupplyForSubcontractDetails != null && this.suratJalanSupplyForSubcontractDetails.length > 0) {
        const msg = this.$createElement;
        const msgNode = msg('div', {
          domProps: {
            innerHTML: '<p>Perubahan terhadap Surat Jalan Supply For Subcontract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
          }
        });
        this.$bvModal.msgBoxConfirm([msgNode], {
          title: 'Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
            .then(value => {
              if (value) {
                this.setSelectedPurchaseOrderExecuted(item);
              }
            })
            .catch(err => {
            })
      } else {
        this.setSelectedPurchaseOrderExecuted(item);
      }
    },
    getVendors: async function (input) {
      let filter = new VendorFilter();
      if (input != undefined) {
        filter.code = input;
      }
      Vendor.getList(this, filter, null, 0, 10)
          .then(result => {
            if (result != null) {
              this.vendors = result.data
            }
          })
          .catch(error => {
          });
    },
    setSelectedVendor(item) {
      if (item == undefined || item == null) {
        this.model.vendorId = null;
        this.model.vendor = null;
      } else {
        this.model.vendorId = item.id;
        this.model.vendor = item;
      }
      this.$forceUpdate();
      this.updateData();
    },
    validateState(name) {
      if (!this.$v.model[name]) return null;
      const {$dirty, $error} = this.$v.model[name];
      return $dirty ? !$error : null;
    },
    getErrorMessage(message, name) {
      if (!this.$v.model[name]) return "";
      if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
        if (message.required) return message.required;
      }
    },
    handleScroll() {
      this.$refs.suratJalanSupplyForSubcontractInput.scrollTop = 0;
    },
    saveAction(modalEvent) {
      modalEvent.preventDefault();
      this.handleScroll();
      let id = this.$route.params.id;
      this.$v.model.$touch();
      if (this.$v.model.$anyError) {
        return;
      } else {
        this.isBusy = true;
        let id = this.modelId;
        let model = this.model;

        if (id != '' && id != null && id != undefined) {
          SuratJalanSupplyForSubcontract.commitData(this, model, id).then(result => {
            this.isDataCommited = true;
            this.$router.push({name: 'suratjalansupplyforsubcontractindex'});
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        } else {
          SuratJalanSupplyForSubcontract.insertData(this, model).then(result => {
            this.isDataCommited = true;
            this.$router.push({name: 'suratjalansupplyforsubcontractindex'});
            this.isBusy = false;
          }).catch(error => {
            this.isBusy = false;
          });
        }
      }
    },
    updateData() {
      let id = this.modelId;
      let model = this.model;
      let promises = Array();

      Promise.all(promises).then((results) => {
        if (id != '' && id != null && id != undefined) {
          SuratJalanSupplyForSubcontract.updateDataDetail(this, model, id)
              .catch((error) => {
                this.getSuratJalanSupplyForSubcontract(id);
              });
        }
      });
    },
    onHidden() {
      this.getSuratJalanSupplyForSubcontracts();
    },
    addRowDataSuratJalanSupplyForSubcontractDetail(modalEvent, model) {
      if (model != null) {
        if (model.id != null && model.id != '') {
          model.suratJalanSupplyForSubcontractId = this.modelId;
          SuratJalanSupplyForSubcontractDetail.updateDataDetail(this, model, model.id)
              .then(result => {
                this.getSuratJalanSupplyForSubcontractDetails(true);
                this.isShowPopupSuratJalanSupplyForSubcontractDetail = false;
              })
        } else {
          model.suratJalanSupplyForSubcontractId = this.modelId;
          SuratJalanSupplyForSubcontractDetail.createDataDetail(this, model)
              .then(result => {
                this.getSuratJalanSupplyForSubcontractDetails(true);
                this.isShowPopupSuratJalanSupplyForSubcontractDetail = false;
              })
        }
      }
    },
    async editRowDataSuratJalanSupplyForSubcontractDetail(id) {
      this.suratJalanSupplyForSubcontractDetailId = id;
      this.isShowPopupSuratJalanSupplyForSubcontractDetail = true;
    },
    async deleteRowDataSuratJalanSupplyForSubcontractDetail(id) {
      SuratJalanSupplyForSubcontractDetail.deleteData(this, id).then(result => {
        this.getSuratJalanSupplyForSubcontractDetails();
      });
    },
    async resetDataSuratJalanSupplyForSubcontractDetail() {
      this.suratJalanSupplyForSubcontractDetailId = "";
      this.isShowPopupSuratJalanSupplyForSubcontractDetail = true;
    },
    async addDataSuratJalanSupplyForSubcontractDetail() {
      SuratJalanSupplyForSubcontractDetail.createData(this, {suratJalanSupplyForSubcontractId: this.modelId})
          .then(result => {
            this.getSuratJalanSupplyForSubcontractDetails(true);
          })
    },
    async addFromClipboardSuratJalanSupplyForSubcontractDetail() {
      let parts = new Array();
      navigator.clipboard.readText().then(value => {
        if (value.match(/(?:\r\n|\r|\n)/g)) {
          value = value.replace(/(?:\r\n|\r|\n)/g, ',');
        }
        let values = value.split(",");
        values.forEach(item => {
          parts.push({part: item, suratJalanSupplyForSubcontractId: this.modelId});
        });
        SuratJalanSupplyForSubcontractDetail.addFromClipboard(this, parts).then(result => {
          this.getSuratJalanSupplyForSubcontractDetails()
        });
      });
    },
    async replaceFromClipboardSuratJalanSupplyForSubcontractDetail() {
      let parts = new Array();
      navigator.clipboard.readText().then(value => {
        if (value.match(/(?:\r\n|\r|\n)/g)) {
          value = value.replace(/(?:\r\n|\r|\n)/g, ',');
        }
        let values = value.split(",");
        values.forEach(item => {
          parts.push({part: item, suratJalanSupplyForSubcontractId: this.modelId});
        });
        SuratJalanSupplyForSubcontractDetail.replaceFromClipboard(this, parts).then(result => {
          this.getSuratJalanSupplyForSubcontractDetails()
        });
      });
    },
    showPopupUploadSuratJalanSupplyForSubcontractDetail() {
      if (this.suratJalanSupplyForSubcontractDetails != null && this.suratJalanSupplyForSubcontractDetails.length > 0) {
        const msg = this.$createElement;
        const msgNode = msg('div', {
          domProps: {
            innerHTML: '<p>Perubahan terhadap SuratJalanSupplyForSubcontractDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
          }
        });
        this.$bvModal.msgBoxConfirm([msgNode], {
          title: 'Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
            .then(value => {
              if (value) {
                this.isShowPopupUploadSuratJalanSupplyForSubcontractDetail = true;
              }
            })
            .catch(err => {
            })
      } else {
        this.isShowPopupUploadSuratJalanSupplyForSubcontractDetail = true;
      }
    },
    uploadDataSuratJalanSupplyForSubcontractDetail(modalEvent, newDatas) {
      this.isShowPopupUploadSuratJalanSupplyForSubcontractDetail = false;
    },
    downloadSuratJalanSupplyForSubcontractDetail(modalEvent) {
      this.isDownloadSuratJalanSupplyForSubcontractDetail = true;
      this.filterSuratJalanSupplyForSubcontractDetail.suratJalanSupplyForSubcontractId = this.modelId;
      SuratJalanSupplyForSubcontractDetail.downloadDataDetail(this, this.filterSuratJalanSupplyForSubcontractDetail).then(result => {
        this.isDownloadSuratJalanSupplyForSubcontractDetail = false;
      }).catch(error => {
        this.isDownloadSuratJalanSupplyForSubcontractDetail = false;
      })
    },
    saveInputSuratJalanSupplyForSubcontractDetail(item) {
      if (this.suratJalanSupplyForSubcontracts != null && this.suratJalanSupplyForSubcontracts != undefined && this.suratJalanSupplyForSubcontracts.length > 0) {
        item.suratJalanSupplyForSubcontract = this.suratJalanSupplyForSubcontracts.find(q => q.id == item.suratJalanSupplyForSubcontractId);
      }
      if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
        item.part = this.parts.find(q => q.id == item.partId);
      }
      if (this.workOrderSupplySubContractDetails != null && this.workOrderSupplySubContractDetails != undefined && this.workOrderSupplySubContractDetails.length > 0) {
        item.workOrderSupplySubcontractDetail = this.workOrderSupplySubContractDetails.find(q => q.id == item.workOrderSupplySubcontractDetailId);
      }

      let id = item.id;
      let promises = Array();

      Promise.all(promises).then((results) => {
        if (id != '' && id != null && id != undefined) {
          SuratJalanSupplyForSubcontractDetail.updateDataDetail(this, item, item.id);
        }
      });
    },
    resetModal(modalType) {
      this.isShowPopupUploadSuratJalanSupplyForSubcontractDetail = false;
      this.isShowPopupSuratJalanSupplyForSubcontractDetail = false;
      if (modalType == 'SuratJalanSupplyForSubcontractDetail') {
        this.getSuratJalanSupplyForSubcontractDetails();
      }
      this.showPopupCopyData = false;
      this.isShowPopupConfirmation = false;
    },
    displayFilter() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 768) {
        //this.isShowSuratJalanSupplyForSubcontractDetailFilter = true;
      }
    },
  },
  beforeMount() {
    this.filterSuratJalanSupplyForSubcontract = new SuratJalanSupplyForSubcontractFilter();
    this.filterSuratJalanSupplyForSubcontractDetail = new SuratJalanSupplyForSubcontractDetailFilter();
    //this.getSuratJalanSupplyForSubcontracts();
    //this.getParts();
    //this.getWorkOrderSupplySubContractDetails();
    //this.getWorkOrderSupplySubContracts();
    //this.getPurchaseOrders();
    //this.getVendors();
  },
  async mounted() {
    let id = this.$route.params.id;
    let copyData = this.$route.params.copydata;
    if (id != '' && id != null && id != undefined) {
      if (copyData != null && copyData != undefined) {
        this.getSuratJalanSupplyForSubcontract(id);
      } else {
        this.modelId = id;
        this.getSuratJalanSupplyForSubcontract(id);
      }
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.displayFilter);
      this.displayFilter();
    });
  },
  computed: {
    isAllowSaveDraft: {
      get: function () {
        if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
        return true;
      }
    }
  },
  watch: {
    sortBySuratJalanSupplyForSubcontractDetail: {
      handler: function () {
        this.getSuratJalanSupplyForSubcontractDetails();
      }
    },
    sortDescSuratJalanSupplyForSubcontractDetail: {
      handler: function () {
        this.getSuratJalanSupplyForSubcontractDetails();
      }
    },
    currentSuratJalanSupplyForSubcontractDetailPage: {
      handler: function () {
        this.getSuratJalanSupplyForSubcontractDetails();
      }
    },
    suratJalanSupplyForSubcontractDetailPageSize: {
      handler: function () {
        this.getSuratJalanSupplyForSubcontractDetails();
      }
    },
    filterSuratJalanSupplyForSubcontractDetail: {
      handler: function () {
        this.getSuratJalanSupplyForSubcontractDetails();
      },
      deep: true,
    },
  },
}
</script>
